import { Text } from '@simplywallst/ui-core';

export const EmptyState = () => (
  <Text typography="xSmall" color="whiteRGBA" opacity={0.5}>
    No diversification data available
  </Text>
);
